import type { PillColor } from './pillStyle';
import type { MaterialType } from '../types/api';

// Job categories, listed in the canonical order: Proxy, CA, Reg, Issuer.
export const CATEGORY_LABEL: Record<string, string> = {
  P: 'Proxy',
  CA: 'Corp Action',
  R: 'Regulatory',
  I: 'Issuer',
};

// Ordered filter list (with an "All" reset) for the category pill row.
export const CATEGORY_FILTERS: { id: string; label: string }[] = [
  { id: 'All', label: 'All' },
  { id: 'P', label: 'Proxy' },
  { id: 'CA', label: 'Corp Action' },
  { id: 'R', label: 'Regulatory' },
  { id: 'I', label: 'Issuer' },
];

// Active-pill colours, one distinct tone per category.
export const CATEGORY_PILL: Record<string, PillColor> = {
  P: { bg: '#DBEAFE', fg: '#1d4ed8' },
  CA: { bg: '#EDE9FE', fg: '#6d28d9' },
  R: { bg: '#E9F6F6', fg: '#0F6E56' },
  I: { bg: '#E0E7FF', fg: '#4338ca' },
};

// job_category -> the first-class materialType discriminator. Issuer (I)
// folds into PROXY — see the MaterialType doc comment in types/api.ts.
export function materialTypeFromCategory(category: string | null): MaterialType {
  if (category === 'CA') return 'CORP_ACTION';
  if (category === 'R') return 'REGULATORY';
  return 'PROXY';
}
